import type { MixedItemTag } from "../tag";
import type { AIFeedbackResponse } from "./ai";
import type { BaseItemContent } from "./content";
import type { ItemFeedback } from "./feedback";
import type { Grading } from "./grading";
import type { ItemMetadata, StimulusMetadata } from "./metadata";
import type { ItemResponse } from "./response";
import type { OriginalItemTypes } from "./types";

export type Answer = {
	selectedChoiceIds?: string[];
	xp?: number;
	score?: number;
	points?: number;
	timeTaken?: number;
	confidence?: number;
	correct?: boolean;
	aiResponse?: AIFeedbackResponse;
	marked?: boolean;
	highlight?: string;
};

export interface BaseItemSchema {
	id?: number;
	versionId?: number;
	recordType: "SCENARIO" | "ITEM";
	type: OriginalItemTypes;
	content: BaseItemContent;
	feedback?: ItemFeedback;
	tags?: MixedItemTag[];
	response: ItemResponse;
	metadata: ItemMetadata;
	stimulus?: BaseItemContent;
	stimulusMetadata?: StimulusMetadata;
	scoring?: Grading;
	answer?: Answer;
	currentStimulusItemIndex?: number;
	numTotalStimulusItems?: number;
	lastUpdatedAt?: string;
	completedAt?: string;
	lastUpdated?: boolean;
}
